import { AxiosResponse } from 'axios';
import {
  ChannelAccountNumber,
  PostClientChannelAccountItem,
  AccountType,
  AccountNumber,
  PostAccountNumbersInputItem,
} from '../types';
import { client } from './axiosClient';

export const getClientChannelAccountNumbers = async (company_id: string) => {
  const res = await client.get<ChannelAccountNumber[]>(
    '/client/channel-account-numbers',
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postClientChannelAccountNumbers = async (
  company_id: string,
  body: PostClientChannelAccountItem[]
) => {
  const res = await client.post<ChannelAccountNumber[]>(
    `/client/channel-account-numbers`,
    body,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getAccountTypes = async () => {
  const res = await client.get<AccountType[]>('/account-type');
  return res.data;
};

export const getClientAccountNumbers = async (company_id: string) => {
  const res = await client.get<AccountNumber[]>(`/client/account-numbers`, {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const postClientAccountNumbers = async (
  company_id: string,
  body: PostAccountNumbersInputItem[]
) => {
  const res = await client.post<
    PostAccountNumbersInputItem[],
    AxiosResponse<AccountNumber[]>
  >(`/client/account-numbers`, body, {
    params: {
      company_id,
    },
  });
  return res.data;
};
